<template>
  <div>
    <p v-if="submitError" class="alert alert-danger">{{submitError}}</p>
    <form name="loginForm" id="login-form" class="form-area auth dynamic" v-on:submit.prevent="submit" novalidate>
      <div class="form-row">
        <p class="text-small" v-if="domain && domain.length > 18">Use your <strong>{{ '@' + domain }}</strong> email.</p>
        <span v-if="persistentEmail">
          <h5 class="email"><i>{{persistentEmail}}</i></h5>
        </span>
        <span v-else>
          <p class="field-error" :class="{ 'show-error' : errors.current === 'email' }">Grr... That is not a valid email</p>
          <div class="input-wrap" :class="{ 'show-error' : errors.current === 'email', 'domain' : domain && domain.length < 18 }">
            <div>
              <input v-model="formData.email"
                id="email"
                ref="email"
                name="email"
                type="text"
                value="formData.email"
                :class="{'active': (activeField.email || !!formData.email)}"
                @focus="emailFocus()" required>
              <label for="email">Email</label>
            </div>
            <span v-if="domain && domain.length < 18"><strong>{{'@' + domain }}</strong></span>
          </div>
        </span>
      </div>
      <div class="form-row">
        <p class="field-error" :class="{ 'show-error' : errors.current === 'password' }">Grr... Please enter a valid password</p>
        <div class="input-wrap" :class="{ 'show-error' : errors.current === 'password' }">
          <input v-model="formData.password"
            id="password" name="password"
            type="password"
            :class="{'active': (activeField.password || !!formData.password)}"
            @focus="passwordFocus()"
            @blur="passwordBlur()" required>
          <label for="password">Password</label>
        </div>
      </div>
      <submit-button :finished="finished" :submitting="submitting" @submit="submit">
        <slot>Join Team</slot>
      </submit-button>
    </form>
  </div>
</template>

<script>
import marketing from '../../services/marketing'
import submitButton from '@/components/submit-button/submit-button'
import is from 'is_js'
import validator from '../../mixins/validator.js'
import { eventBus } from '@/services/bus.js'

export default {
  name: 'login-signup-form',
  components: {
    'submit-button': submitButton
  },
  props: ['email', 'persistentEmail', 'domain'],
  mixins: [validator],
  data () {
    return {
      is: is,
      activeField: {
        email: false,
        password: false
      },
      formData: {
        email: this.email || '',
        password: ''
      },
      submitted: false,
      submitting: false,
      finished: false,
      submitError: ''
    }
  },
  computed: {
    validations: function () {
      let validations = {
        'password': [this.formData.password, this.formData.password.length > 7]
      }
      if (!this.persistentEmail && !this.domain) {
        validations.email = [this.formData.email, this.is.email(this.formData.email)]
      } else if (this.domain) {
        validations.email = [this.formData.email]
      }
      return validations
    }
  },
  methods: {
    makeRequest: function () {
      if (this.submitting) return
      this.submitting = true
      this.submitError = ''
      let addedDomain = ''
      if (this.domain && this.formData.email.indexOf('@') === -1) {
        addedDomain = '@' + this.domain
      }

      let data = {
        email: (this.formData.email || this.persistentEmail) + addedDomain,
        password: this.formData.password,
        withUserDetails: true,
        noconfirm: true
      }
      data = Object.assign(data, marketing.marketingParams())

      this.$store.dispatch('loginSignup', data).then((response) => {
        this.submitting = false
        this.finished = true
      }).catch((error) => {
        if (error.data && error.data.v2ErrorCode === 11006) {
          this.submitError = 'Grrr, we think your password will be easily guessed. Please create a stronger password.'
        } else if (error.data && error.data.v2ErrorCode === 11002) {
          this.submitError = 'Rawr! That email is a little too long for your Bear to remember. Try using one that\'s 45 characters or less.'
        } else if (error.data && error.data.v2ErrorCode === 11009) {
          this.submitError = 'Grrr, it looks like your TunnelBear app is running. Please disconnect it to create an account.'
        } else if (error.data && error.data.v2ErrorCode === 11004) {
          this.submitError = 'Rawr! Try using a password that\'s less than 45 characters.'
        } else if (error.response && error.response.status === 429) {
          this.submitError = 'Hold your bears! You\'ve tried that too many times. Please try again in a few minutes.'
        } else if (error.response && error.response.status === 403) {
          this.submitError = 'Grrr… An account with this email exists, but the password you entered is incorrect.'
        } else {
          this.submitError = 'We can\'t seem to find that email and password combination, try another?'
        }
        this.submitting = false
      })
    },
    submit: function () {
      this.submitted = true
      if (this.errors.all.length === 0) {
        this.makeRequest()
      }
    },
    emailFocus: function () {
      this.activeField.email = true
      eventBus.$emit('emailInputFocus')
    },
    passwordFocus: function () {
      this.activeField.password = true
      eventBus.$emit('passwordInputFocus')
    },
    passwordBlur: function () {
      eventBus.$emit('passwordInputBlur')
    }
  },
  watch: {
    'formData.email': {
      handler: function () {
        eventBus.$emit('emailInputTyping', this.formData.email.length)
      }
    }
  }
}
</script>

<style scoped lang="stylus" src="./login-signup-form.styl" >



// WEBPACK FOOTER //
// src/components/login-signup-form/login-signup-form.vue